import { useEffect } from 'react';
import { useAuthStore } from '@stores/authStore';
import { useVoiceAgentStore } from '@stores/voiceAgentStore';
import { useWebSocket } from '@/hooks/useWebSocket';
import voiceService from '@services/voice.service';
import { applyOutboundUpdate, endHeldOutboundCall, recoverOutboundCall } from '../outboundCall';

/** Live updates can be missed, so a call in progress also asks now and then. */
const POLL_MS = 5_000;

/** Follows the call this agent placed to a customer. Sits in the layout beside BridgePhone. */
export function OutboundCallPhone() {
  const userId = useAuthStore((s) => s.user?.id);
  const mediaUrl = useVoiceAgentStore((s) => s.mediaUrl);
  const callId = useVoiceAgentStore((s) => s.outgoingCall?.callId);
  const { on, off } = useWebSocket();

  useEffect(() => {
    if (!userId) endHeldOutboundCall();
  }, [userId]);

  useEffect(() => {
    if (!userId) return;
    on('voice:outbound:updated', applyOutboundUpdate);
    return () => off('voice:outbound:updated', applyOutboundUpdate);
  }, [userId, on, off]);

  // Needs the media address, which arrives once the phone is set up.
  useEffect(() => {
    if (!userId || !mediaUrl) return;
    recoverOutboundCall().catch(() => {});
  }, [userId, mediaUrl]);

  useEffect(() => {
    if (!callId) return;
    const timer = setInterval(() => {
      voiceService.getOutboundCall(callId).then(applyOutboundUpdate).catch(() => {});
    }, POLL_MS);
    return () => clearInterval(timer);
  }, [callId]);

  return null;
}
